export default __webpack_public_path__ + "static/media/man-pilgrim.b1eab338.svg";